import React from "react"

function QuestionCircle({ width, height, fill }) {
  return (
    <svg
      width={width || "17"}
      height={height || "20"}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.79962 11.144L9.32562 10.696C9.18562 10.57 9.07362 10.332 9.07362 10.108C9.07362 8.932 11.4116 8.778 11.4116 6.734C11.4116 5.432 10.3056 4.522 8.49962 4.522C7.29562 4.522 6.17562 5.012 5.43362 5.88L6.56762 7.154C7.00162 6.636 7.58962 6.286 8.28962 6.286C9.05962 6.286 9.38162 6.65 9.38162 7.084C9.38162 8.05 7.33762 8.246 7.33762 9.912C7.33762 10.402 7.50562 10.822 7.79962 11.144ZM8.47162 14.154C9.08762 14.154 9.60562 13.636 9.60562 13.02C9.60562 12.404 9.08762 11.886 8.47162 11.886C7.85562 11.886 7.33762 12.404 7.33762 13.02C7.33762 13.636 7.85562 14.154 8.47162 14.154Z"
        fill={fill || "#D1D1D1"}
      />
      <circle cx="8.5" cy="9.5" r="8" stroke={fill || "#CACACA"} />
    </svg>
  )
}

export default QuestionCircle
